'use client'

import styled from 'styled-components'

export const MarkedDownPrice = styled.span`
  color: ${o => o.theme.color.text.critical.on.background};
`
